<div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
<div *ngIf="info" class="alert alert-info mt-3 mb-0">{{info}}</div>

